// Category pages are bare top-level routes (/{catSlug}, /{catSlug}/{citySlug}) with no
// distinguishing URL prefix — this is the shared logic for telling them apart from the
// other top-level routes and from pro-profile pages (/{catSlug}/{proSlug}-{id}).

const RESERVED_TOP = new Set([
  'about', 'join', 'privacy', 'contact', 'terms', 'admin', 'api', 'expert', 'category',
  'articles', 'sitemap.xml', 'robots.txt', 'llms.txt', 'multi', // multi landing /multi/<slug> (02/10/26) — never a category
  'קטגוריה', 'מומחה', 'אודות', 'הצטרף', 'פרטיות', 'צור-קשר', 'תנאים', 'מאמרים', 'עסק',
]);

export function isReservedTopSegment(seg: string): boolean {
  try { return RESERVED_TOP.has(decodeURIComponent(seg)); } catch { return RESERVED_TOP.has(seg); }
}

/** True for /{catSlug} or /{catSlug}/{citySlug} — false for pro pages (2nd segment ends
 *  in -{id}), reserved top-level routes, and the home page. */
export function isCategoryPath(pathname: string | null | undefined): boolean {
  const segs = (pathname || '').split('/').filter(Boolean);
  if (segs.length === 0) return false;
  if (/^\d+$/.test(segs[0])) return false; // /4139 = a pro page (its number is its URL), never a category
  if (isReservedTopSegment(segs[0])) return false;
  if (segs.length === 1) return true;
  if (segs.length === 2 && !/-\d+$/.test(segs[1])) return true;
  // service page /<cat>/s/<service>[/<city>] (21/10/26) renders CategoryPageBody — same chrome rules as the category page
  if ((segs.length === 3 || segs.length === 4) && segs[1] === 's') return true;
  return false;
}

/** First path segment as a category slug, or null when it's a reserved/home route. */
export function categorySlugFromPath(pathname: string | null | undefined): string | null {
  const firstSeg = (pathname || '').split('/').filter(Boolean)[0];
  if (!firstSeg || /^\d+$/.test(firstSeg) || isReservedTopSegment(firstSeg)) return null;
  try { return decodeURIComponent(firstSeg); } catch { return firstSeg; }
}
